function updateSceneEvidenceHeight() {
  const container = document.querySelector(".scene-evidence--wrapper");
  if (!container) return;

  const items = container.querySelectorAll(".img-ev__container:not(.img-ev__container--hidden)");
  if (!items.length) return;

  let maxBottom = 0;

  items.forEach((el) => {
    const rect = el.getBoundingClientRect();
    const style = window.getComputedStyle(el);
    const top = parseFloat(style.top) || 0;
    const height = el.offsetHeight;

    const bottom = top + height;
    if (bottom > maxBottom) maxBottom = bottom;
  });

  // add padding space as before
  const extra = 300;
  container.style.height = `${maxBottom + extra}px`;
}

let evResizeTimer;

function handleEvidenceResize() {
  clearTimeout(evResizeTimer);
  evResizeTimer = setTimeout(() => {
    updateSceneEvidenceHeight();
    if (window.gsap && window.ScrollTrigger) {
      ScrollTrigger.refresh();
    }
  }, 150);
}

window.addEventListener("orientationchange", () => {
  setTimeout(() => {
    updateSceneEvidenceHeight();
    ScrollTrigger.refresh();
  }, 200);
});

window.addEventListener("resize", handleEvidenceResize);

export function appendImagesEvidence() {
  const imgBottle = `
  <img class="scene-evidence__img scene-evidence__img--bottle" src="/uploads/images/evidence/bottle.webp" alt="Jon Rye Bottle">
  `;

  const imgNose = `
  <img class="scene-evidence__img scene-evidence__img--stamp scene-evidence__img--nose" src="/uploads/images/evidence/nose.webp" alt="Nose notes">
  `;

  const imgTaste = `
  <img class="scene-evidence__img scene-evidence__img--stamp scene-evidence__img--taste" src="/uploads/images/evidence/taste.webp" alt="Taste notes">
  `;
  const imgN1 = `
  <div class="img-ev__container img-ev__container--1">
    <img class="img-ev__img img-ev__img--1" src="/uploads/images/evidence/1/1-vanilla-img-flower.webp" alt="Vanilla nose notes - image of vanilla beans">
    <img class="img-ev__pin img-ev__pin--1" src="/uploads/images/evidence/1/1-vanilla-pin.webp" alt="" data-pin="1" data-offset-x="-1" data-offset-y="-1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--1" src="/uploads/images/evidence/1/1-vanilla-pin.webp" alt="" data-pin="1" data-offset-x="-1" data-offset-y="-1">
 </div>

   <div class="img-ev__container img-ev__container--hidden img-ev__container--1">
    <img class="img-ev__img img-ev__img--1" src="/uploads/images/evidence/1/1-vanilla-img-flower.webp" alt="Vanilla nose notes - image of vanilla beans">
    <img class="img-ev__pin img-ev__pin--1" src="/uploads/images/evidence/1/1-vanilla-pin.webp" alt="" data-pin="1" data-offset-x="-1" data-offset-y="-1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--1" src="/uploads/images/evidence/1/1-vanilla-pin.webp" alt="" data-pin="1" data-offset-x="-1" data-offset-y="-1">
 </div>
    `;

  const imgN2 = `
<div class="img-ev__container img-ev__container--2">
    <img class="img-ev__img img-ev__img--2" src="/uploads/images/evidence/2/2-sugar-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--2" src="/uploads/images/evidence/2/2-sugar-pin.webp" alt="" data-pin="2" data-offset-x="-1" data-offset-y="-1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--2" src="/uploads/images/evidence/2/2-sugar-pin.webp" alt="" data-pin="2" data-offset-x="-1" data-offset-y="-1">
</div>

<div class="img-ev__container img-ev__container--hidden img-ev__container--2">
    <img class="img-ev__img img-ev__img--2" src="/uploads/images/evidence/2/2-sugar-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--2" src="/uploads/images/evidence/2/2-sugar-pin.webp" alt="" data-pin="2" data-offset-x="-1" data-offset-y="-1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--2" src="/uploads/images/evidence/2/2-sugar-pin.webp" alt="" data-pin="2" data-offset-x="-1" data-offset-y="-1">
</div>
    `;

  const imgN3 = `
<div class="img-ev__container img-ev__container--3">
    <img class="img-ev__img img-ev__img--3" src="/uploads/images/evidence/3/3-peach-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--3" src="/uploads/images/evidence/3/3-peach-pin.webp" alt="" data-pin="3" data-offset-x="2">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--3" src="/uploads/images/evidence/3/3-peach-pin.webp" alt="" data-pin="3" data-offset-x="2">
 </div>
   
 
 <div class="img-ev__container img-ev__container--hidden img-ev__container--3">
    <img class="img-ev__img img-ev__img--3" src="/uploads/images/evidence/3/3-peach-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--3" src="/uploads/images/evidence/3/3-peach-pin.webp" alt="" data-pin="3" data-offset-x="2">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--3" src="/uploads/images/evidence/3/3-peach-pin.webp" alt="" data-pin="3" data-offset-x="2">
 </div>
 
 `;

  const imgN4 = `
<div class="img-ev__container img-ev__container--4">
    <img class="img-ev__img img-ev__img--4" src="/uploads/images/evidence/4/4-rye-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--4" src="/uploads/images/evidence/4/4-rye-pin.webp" alt="" data-pin="4" data-offset-x="3">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--4" src="/uploads/images/evidence/4/4-rye-pin.webp" alt="" data-pin="4" data-offset-x="3">
</div>

<div class="img-ev__container img-ev__container--hidden img-ev__container--4">
    <img class="img-ev__img img-ev__img--4" src="/uploads/images/evidence/4/4-rye-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--4" src="/uploads/images/evidence/4/4-rye-pin.webp" alt="" data-pin="4" data-offset-x="3">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--4" src="/uploads/images/evidence/4/4-rye-pin.webp" alt="" data-pin="4" data-offset-x="3">
</div>
    `;

  const imgN5 = `
<div class="img-ev__container img-ev__container--5">
    <img class="img-ev__img img-ev__img--5" src="/uploads/images/evidence/5/5-baking-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--5" src="/uploads/images/evidence/5/5-baking-pin.webp" alt="" data-pin="5" data-offset-x="1">
    <img class="img-ev__pin  img-ev__pin--hidden img-ev__pin--5" src="/uploads/images/evidence/5/5-baking-pin.webp" alt="" data-pin="5" data-offset-x="1">
</div>

<div class="img-ev__container img-ev__container--hidden img-ev__container--5">
    <img class="img-ev__img img-ev__img--5" src="/uploads/images/evidence/5/5-baking-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--5" src="/uploads/images/evidence/5/5-baking-pin.webp" alt="" data-pin="5" data-offset-x="1">
    <img class="img-ev__pin  img-ev__pin--hidden img-ev__pin--5" src="/uploads/images/evidence/5/5-baking-pin.webp" alt="" data-pin="5" data-offset-x="1">
</div>
    `;

  const imgN6 = `
<div class="img-ev__container img-ev__container--6">
    <img class="img-ev__img img-ev__img--6" src="/uploads/images/evidence/6/6-cereal-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--6" src="/uploads/images/evidence/6/6-cereal-pin.webp" alt="" data-pin="6" data-offset-x="-7" data-offset-y="-1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--6" src="/uploads/images/evidence/6/6-cereal-pin.webp" alt="" data-pin="6" data-offset-x="-7" data-offset-y="-1">
 </div>

 <div class="img-ev__container img-ev__container--hidden img-ev__container--6">
    <img class="img-ev__img img-ev__img--6" src="/uploads/images/evidence/6/6-cereal-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--6" src="/uploads/images/evidence/6/6-cereal-pin.webp" alt="" data-pin="6" data-offset-x="-7" data-offset-y="-1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--6" src="/uploads/images/evidence/6/6-cereal-pin.webp" alt="" data-pin="6" data-offset-x="-7" data-offset-y="-1">
 </div>
    `;

  const imgN7 = `
<div class="img-ev__container img-ev__container--7">
    <img class="img-ev__img img-ev__img--7" src="/uploads/images/evidence/7/7-rye-spice-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--7" src="/uploads/images/evidence/7/7-rye-spice-pin.webp" alt="" data-pin="7" data-offset-x="1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--7" src="/uploads/images/evidence/7/7-rye-spice-pin.webp" alt="" data-pin="7" data-offset-x="1">
</div>

<div class="img-ev__container img-ev__container--hidden img-ev__container--7">
    <img class="img-ev__img img-ev__img--7" src="/uploads/images/evidence/7/7-rye-spice-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--7" src="/uploads/images/evidence/7/7-rye-spice-pin.webp" alt="" data-pin="7" data-offset-x="1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--7" src="/uploads/images/evidence/7/7-rye-spice-pin.webp" alt="" data-pin="7" data-offset-x="1">
</div>
    `;

  const imgN8 = `
  <div class="img-ev__container img-ev__container--8">
    <img class="img-ev__img img-ev__img--8" src="/uploads/images/evidence/8/8-vanilla-taste-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--8" src="/uploads/images/evidence/8/8-vanilla-taste-pin.webp" alt="" data-pin="8" data-offset-x="-3" data-offset-y="-1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--8" src="/uploads/images/evidence/8/8-vanilla-taste-pin.webp" alt="" data-pin="8" data-offset-x="-3" data-offset-y="-1">
 </div>

   <div class="img-ev__container img-ev__container--hidden img-ev__container--8">
    <img class="img-ev__img img-ev__img--8" src="/uploads/images/evidence/8/8-vanilla-taste-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--8" src="/uploads/images/evidence/8/8-vanilla-taste-pin.webp" alt="" data-pin="8" data-offset-x="-3" data-offset-y="-1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--8" src="/uploads/images/evidence/8/8-vanilla-taste-pin.webp" alt="" data-pin="8" data-offset-x="-3" data-offset-y="-1">
 </div>
    `;

  const imgN9 = `
<div class="img-ev__container img-ev__container--9">
    <img class="img-ev__img img-ev__img--9" src="/uploads/images/evidence/9/9-butter-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--9" src="/uploads/images/evidence/9/9-butter-pin.webp" alt="" data-pin="9">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--9" src="/uploads/images/evidence/9/9-butter-pin.webp" alt="" data-pin="9">
</div>

<div class="img-ev__container img-ev__container--hidden img-ev__container--9">
    <img class="img-ev__img img-ev__img--9" src="/uploads/images/evidence/9/9-butter-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--9" src="/uploads/images/evidence/9/9-butter-pin.webp" alt="" data-pin="9">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--9" src="/uploads/images/evidence/9/9-butter-pin.webp" alt="" data-pin="9">
</div>
    `;

  const imgN10 = `
<div class="img-ev__container img-ev__container--10">
    <img class="img-ev__img img-ev__img--10" src="/uploads/images/evidence/10/10-appricot-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--10" src="/uploads/images/evidence/10/10-appricot-pin.webp" alt="" data-pin="10" data-offset-x="3" data-offset-y="-1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--10" src="/uploads/images/evidence/10/10-appricot-pin.webp" alt="" data-pin="10" data-offset-x="3" data-offset-y="-1">
</div>

<div class="img-ev__container img-ev__container--hidden img-ev__container--10">
    <img class="img-ev__img img-ev__img--10" src="/uploads/images/evidence/10/10-appricot-img.webp" alt="Candied sugar nose notes - image of candied sugar">
    <img class="img-ev__pin img-ev__pin--10" src="/uploads/images/evidence/10/10-appricot-pin.webp" alt="" data-pin="10" data-offset-x="3" data-offset-y="-1">
    <img class="img-ev__pin img-ev__pin--hidden img-ev__pin--10" src="/uploads/images/evidence/10/10-appricot-pin.webp" alt="" data-pin="10" data-offset-x="3" data-offset-y="-1">
</div>
    `;

  $(".scene-evidence").append(`
     ${imgBottle}
    <div class="scene-evidence--wrapper">
<svg class="evidence-svg" width="100%" height="100%" style="position:absolute; top:0; left:0; pointer-events:none;">
  <path class="evidence-path" fill="none" stroke="#fff" stroke-width="2"></path>
</svg>

<div class="scene-evidence__bg--container"><div class="scene-evidence__bg--img"></div></div>
${imgNose}${imgTaste}${imgN1}${imgN2}${imgN3}${imgN4}${imgN5}${imgN6}${imgN7}${imgN8}${imgN9}${imgN10}
</div>
    `);

  updateSceneEvidenceHeight();
  ScrollTrigger.refresh();
}
